module.exports = __webpack_public_path__ + "static/media/more-unselected.1215a3ce.svg";